exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo_div[data-v-7a1a118d]{width:100%;margin-top:-100px;height:300px;background-color:#e52212;border-radius:60px}.logo_title[data-v-7a1a118d]{font-size:40px;font-weight:bolder;color:#fff;position:absolute;width:100%;text-align:center;margin-top:170px}", ""]);

// exports
